import LinuxListeningTentacleCallout from "./LinuxListeningTentacleCallout";
import LinuxPollingTentacleCallout from "./LinuxPollingTentacleCallout";
import WindowsListeningTentacleCallout from "./WindowsListeningTentacleCallout";
import WindowsPollingTentacleCallout from "./WindowsPollingTentacleCallout";

export { WindowsListeningTentacleCallout, LinuxListeningTentacleCallout, WindowsPollingTentacleCallout, LinuxPollingTentacleCallout };
